export default __webpack_public_path__ + "static/media/ic_East_Timor.b6f6b1a5.svg";